import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from '../lib/icons';
const RECENT_SALES = [{
  name: 'Romina S.',
  location: 'Córdoba'
}, {
  name: 'Gabriela M.',
  location: 'Rosario'
}, {
  name: 'Soledad P.',
  location: 'Buenos Aires'
}, {
  name: 'Mariana L.',
  location: 'Mendoza'
}, {
  name: 'Florencia R.',
  location: 'La Plata'
}, {
  name: 'Valentina T.',
  location: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialTimeout = setTimeout(() => setIsVisible(true), 4000);
    const cycleInterval = setInterval(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % RECENT_SALES.length);
          setIsVisible(true);
        }, 200);
      }, 300);
    }, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [dismissed]);
  const handleDismiss = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimatingOut(false);
      setDismissed(true);
    }, 300);
  };
  const currentSale = RECENT_SALES[currentIndex];
  if (dismissed) return null;
  if (!isVisible && !isAnimatingOut) return null;
  return <div className={`fixed bottom-[76px] md:bottom-4 left-2 md:left-4 z-[45] max-w-[180px] md:max-w-[220px] ${isAnimatingOut ? 'animate-popup-out' : 'animate-popup-in'}`} data-id="element-481">
      <div className="bg-white rounded-lg p-2.5 shadow-lg border border-gray-200 relative group" data-id="element-482">
        <button onClick={handleDismiss} className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-100 border border-gray-300 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors shadow-sm" data-id="element-483">
          <XIcon size={10} data-id="element-484" />
        </button>

        <div className="flex items-start gap-2" data-id="element-485">
          <div className="bg-green-100 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-486">
            <CheckCircle2Icon className="w-3 h-3 text-green-600" data-id="element-487" />
          </div>
          <div className="min-w-0" data-id="element-488">
            <p className="text-[0.68rem] text-gray-800 font-medium leading-tight" data-id="element-489">
              <span className="font-bold" data-id="element-490">{currentSale.name}</span> de{' '}
              {currentSale.location}
            </p>
            <p className="text-[0.6rem] text-gray-500 mt-0.5 leading-snug" data-id="element-491">
              adquirió el{' '}
              <span className="text-green-700 font-semibold" data-id="element-492">
                Curso de Reiki
              </span>
            </p>
            <div className="flex items-center gap-1 mt-1" data-id="element-493">
              <div className="w-1 h-1 bg-green-500 rounded-full animate-pulse" data-id="element-494"></div>
              <span className="text-[8px] text-gray-400 uppercase tracking-wider font-semibold" data-id="element-495">
                Verificado
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}